<div class="text-end w-100">
  @if (props.compareValue) {
    <span class="apm-text-gray {{ field.className }}">({{ props.compareValue }})</span>
  }
  {{ field.defaultValue }} {{ props.uom }}
</div>
